import { colors } from '../../../themes/colors';

export const spinnerMarketingTheme = {
  color: colors.yellow[600],
};
